import React from 'react';
import {
  familyAwareOfPrognosisOptions,
  palliativeCareRegisterOptions,
} from './commons';

interface PalliativeCareRegisterSectionProps {
  residentFullName: string;
  isOnPalliativeCareRegister: string;
  familyAwareOfPrognosis: string;
  updateEndOfLifeCare: (
    field: 'isOnPalliativeCareRegister' | 'familyAwareOfPrognosis',
    value: string
  ) => void;
}

const PalliativeCareRegisterSection: React.FC<
  PalliativeCareRegisterSectionProps
> = ({
  residentFullName,
  isOnPalliativeCareRegister,
  familyAwareOfPrognosis,
  updateEndOfLifeCare,
}) => {
  return (
    <div className="mt-10 govuk-bp:mt-14">
      <h2 className="govuk-heading-l">Palliative Care Register</h2>

      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">Learn more</span>
        </summary>

        <div className="govuk-details__text">
          <p className="govuk-body">
            Early identification of people likely to be in their last year(s) of
            life provides opportunity for honest conversations about what
            matters to the person and facilitates care for them which is aligned
            to their needs and preferences. It can support an MDT approach to
            care that is coordinated between professionals and proactive to meet
            the changing need of the patient. A palliative care register,
            commonly used within primary care, can be used to identify patients
            who may be in their last year(s) of life. It is recommended that,
            where possible, an explanation of this process is provided to the
            patient and their family/carer.
          </p>
        </div>
      </details>

      <div className="govuk-form-group">
        <label
          className="govuk-label govuk-label--s"
          htmlFor="palliative-care-register"
        >
          Is {residentFullName} on the Palliative Care Register?
        </label>

        <select
          className="govuk-select govuk-!-width-one-half"
          id="palliative-care-register"
          name="isOnPalliativeCareRegister"
          value={isOnPalliativeCareRegister}
          onChange={e =>
            updateEndOfLifeCare('isOnPalliativeCareRegister', e.target.value)
          }
        >
          {palliativeCareRegisterOptions.map(option => (
            <option key={option.value || 'select'} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <label
          className="govuk-label govuk-label--s"
          htmlFor="family-aware-of-prognosis"
        >
          Is the family aware of prognosis?
        </label>

        <select
          className="govuk-select govuk-!-width-one-half"
          id="family-aware-of-prognosis"
          name="familyAwareOfPrognosis"
          value={familyAwareOfPrognosis}
          onChange={e =>
            updateEndOfLifeCare('familyAwareOfPrognosis', e.target.value)
          }
        >
          {familyAwareOfPrognosisOptions.map(option => (
            <option key={option.value || 'select'} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PalliativeCareRegisterSection;
